import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';

import _ from 'lodash';

import { UserActions } from '../../actions';

class MenuDrawer extends Component {
  componentWillMount() {
    const { user, dispatch } = this.props;
    if (!user || !user.company) {
      dispatch(UserActions.getCompany());
    }
  }

  gotoDashboard() {
    browserHistory.push('/dashboard');
  }
  gotoOrders() {
    browserHistory.push('/orders');
  }
  gotoLocations() {
    browserHistory.push('/locations');
  }

  gotoTrackers() {
    browserHistory.push('/fleet/trackers');
  }
  gotoUnits() {
    browserHistory.push('/fleet/units');
  }
  gotoTrailers() {
    browserHistory.push('/fleet/trailers');
  }


  gotoCompanies() {
    browserHistory.push('/admin/companies');
  }
  gotoUsers() {
    browserHistory.push('/admin/users');
  }
  gotoDrivers() {
    browserHistory.push('/admin/drivers');
  }

  gotoDispatch() {
    browserHistory.push('/dispatcher/dispatch');
  }
  gotoInbound() {
    browserHistory.push('/dispatcher/inbound');
  }
  gotoOutbound() {
    browserHistory.push('/dispatcher/outbound');
  }
  gotoManifests() {
    browserHistory.push('/dispatcher/manifests');
  }

  render() {
    const { user } = this.props;
    const role = _.get(user, 'profile.roles');

    const isAdmin = role === 'super-admin';
    const isCarrierAdmin = role === 'carrier-admin';
    const isShipperAdmin = role === 'shipper-admin';
    const isDispatcher = _.includes(['carrier-dispatch'], role);

    const menuItems = [
      { type: 'menuitem', onClick: this.gotoDashboard, label: 'Dashboard' },
    ];

    if (_.includes(['super-admin', 'carrier-admin', 'carrier-dispatch', 'shipper-admin'], role)) {
      if (_.get(user, 'profile.isShipper') === false || _.get(user, 'company.features.orders', false)) {
        menuItems.push({ type: 'divider' });
        menuItems.push({ type: 'menuitem', onClick: this.gotoOrders, label: 'Orders' });
        menuItems.push({ type: 'menuitem', onClick: this.gotoLocations, label: 'Locations' });
      }

      if (isDispatcher || isAdmin || isCarrierAdmin) {
        menuItems.push({ type: 'divider' });
        menuItems.push({ type: 'menuitem', onClick: this.gotoDispatch, label: 'Dispatch' });
        menuItems.push({ type: 'menuitem', onClick: this.gotoInbound, label: 'Inbound' });
        menuItems.push({ type: 'menuitem', onClick: this.gotoManifests, label: 'Manifests' });
      }

      if (_.get(user, 'company.data', false) && _.get(user, 'company.data.units') || _.get(user, 'company.data.containers') || _.get(user, 'company.data.trackers')) {
        menuItems.push({ type: 'divider' });
        if (_.get(user, 'company.data.trackers')) menuItems.push({ type: 'menuitem', onClick: this.gotoTrackers, label: 'Trackers' });
        if (_.get(user, 'company.data.units')) menuItems.push({ type: 'menuitem', onClick: this.gotoUnits, label: 'Units' });
        if (_.get(user, 'company.data.containers')) menuItems.push({ type: 'menuitem', onClick: this.gotoTrailers, label: 'Trailers' });
      }
    }

    if (isAdmin || isCarrierAdmin || isShipperAdmin) {
      menuItems.push({ type: 'divider' });
      if (isAdmin) menuItems.push({ type: 'menuitem', onClick: this.gotoCompanies, label: 'Carriers' });
      if (isAdmin || isCarrierAdmin) menuItems.push({ type: 'menuitem', onClick: this.gotoCompanies, label: 'Shippers' });
      menuItems.push({ type: 'menuitem', onClick: this.gotoUsers, label: 'Users' });
      if (isAdmin || isCarrierAdmin) menuItems.push({ type: 'menuitem', onClick: this.gotoDrivers, label: 'Drivers' });
    }

    const content = menuItems.map((item, key) => {
      if (item.type === 'menuitem') {
        return (<MenuItem key={key} onTouchTap={item.onClick}>{item.label}</MenuItem>);
      }
      return (<Divider key={key} />);
    });

    return (
      <Drawer open={this.props.open} docked={false} onRequestChange={this.props.onRequestChange}>
        <AppBar title="Menu" showMenuIconButton={false} />
        {content}
      </Drawer>
    );
  }
}

MenuDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onRequestChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { auth, user } = state;
  return {
    auth: auth.auth,
    user
  }
}

export default connect(mapStateToProps)(MenuDrawer);


// WEBPACK FOOTER //
// ./src/components/MenuDrawer/index.js